<template>
  <div class="root-container" v-if="forceUpdateFlag">
    <div v-if="!viewLayout.length" style="display: flex;flex-direction: column;align-items: center;justify-content: center;height: 100%;">
      <img src="@/assets/img/empty.png" alt="empty" class="empty-img"></img>
      <div style="font-size: 14px;color: #999;">从左侧组件面板中点击或拖拽组件到画布中</div>
    </div>
    <grid-layout ref="gridlayout" class="gridlayout" :layout.sync="viewLayout" :col-num="cols" :responsive="responsive"
      :row-height="30" :is-draggable="true" :is-resizable="true" :vertical-compact="true" :use-css-transforms="false">
      <grid-item drag-allow-from=".bi-layout-drag-handle"
      v-if="!item.hide"
        :style="{ background: item.styleConfig && item.styleConfig.commongConfig.customBackgroundColor ? item.styleConfig.commongConfig.backgroundColor : '#fff' }"
        :key="`${item._id}_${item.tempKey || ''}`" v-for="item in viewLayout" :static="getPreviewFlag" @resized="resizedEvent(item)" :x="item.x"
        :y="item.y" :w="item.w" :h="item.h" drag-ignore-from=".jzliu-bi-engine-middle-layer" :i="item.i">
        <div class="bi-layout-drag-handle">
          <div><i class="el-icon-more"></i></div>
          <div><i class="el-icon-more"></i></div>
        </div>
        <div class="jzliu-bi-engine-chart-warp grid-warp" :class="{ shadow: item._id === cur._id }">
          <middle-layer :dashboardName="dashboardName" :chartDirection="chartDirection" :chartPreviewMode="chartPreviewMode" :previewMode="previewMode" :chartConfigHandler="chartConfigHandler" @sort-change="handleSortChange" :ref="`middle_${item._id}`" @drill-item-click="handleDrillItemClick" @handle-table-command="handleTableCommand" @click.native="chartSelect(item)" :chartData="item" @table-page-change="handleTablePageChange"></middle-layer>
        </div>
      </grid-item>
    </grid-layout>
    <div class="gap"></div>
  </div>
</template>

<script>
import { GridLayout, GridItem } from 'vue-grid-layout'
import middleLayer from './charts/middleLayer'
// 移除 Vuex 依赖，使用 props 传递状态
import { elResizeObverse } from '../utils'
const _ = require('lodash')

export default {
  name: 'canvasPanel',
  components: { GridLayout, GridItem, middleLayer },
  props: {
    dashboardName: {
      type: String,
      default: '',
    },
    chartDirection: {
      type: String,
      default: 'rtl'
    },
    chartPreviewMode: {
      type: String,
      default: 'dialog'
    },
    previewMode: {
      type: String,
      default: 'drawer'
    },
    chartData: {
      type: Object,
      default: () => {},
    },
    gridLayout: {
      type: Array,
      default: () => [],
    },
    previewFlag: {
      type: Boolean,
      default: false,
    },
    chartConfigHandler: {
      type: Function,
      default: (conf) => conf,
    },
  },
  data() {
    return {
      cols: 12,
      draggable: true,
      resizable: true,
      responsive: false,
      forceUpdateFlag: true,
      index: 0,
      cur: {},
      observer: null,
    }
  },
  computed: {
    // 使用 props 传递的状态
    getPreviewFlag() {
      return this.previewFlag
    },
    viewLayout: {
      get() {
        return this.gridLayout
      },
      set(val) {
        let isEffect = val.filter((v) => !v._id)
        if (!!isEffect.length) return
        this.$emit('update:gridLayout', val)
      },
    },
  },
  watch: {
    gridLayout(newList, oldList) {
      let oldIds = oldList.filter((v) => !!v._id).map((v) => v._id)
      let newRealList = newList.filter((v) => !!v._id)
      const addIndex = newRealList.findIndex((v) => !oldIds.includes(v._id))
      if (addIndex !== -1) {
        this.chartSelect(newRealList[addIndex])
      }
      this.viewLayout = newList
    },
  },
  mounted() {
    // 响应式监测 针对pc和移动端之间切换的兼容
    const el = document.querySelector('.gridlayout')
    elResizeObverse(el, () => {
      const { width } = el.getBoundingClientRect()
      let h = 0
      this.viewLayout.forEach((v) => {
        if (width <= 600) {
          v.ow = v.w ?? v.ow
          v.oy = v.y ?? v.oy
          v.w = 12
          h += v.h
        } else {
          v.w = v.ow ?? v.w
          v.y = v.oy ?? v.y
          delete v.ow
          delete v.oy
        }
      })
      // 强制触发刷新mount让grid重新计算
      if (width <= 600) {
        this.forceUpdateFlag = false
        this.forceUpdateFlag = true
      }
    })
  },
  methods: {
    handleSortChange(column) {
      this.$emit('sort-change', column)
    },
    previewDetail(selectItem) {
      this.$refs[`middle_${selectItem._id}`]?.[0]?.handleCommand('dwsPreview')
    },
    resizedEvent(item) {
      item.tempKey = `${item.w}_${item.h}`
      // 触发 resize 事件，让父组件处理
      this.$emit('grid-resize', item)
    },
    chartSelect(item) {
      this.gridLayout.forEach((v) => {
        v._select = false
      })
      item._select = true
      this.cur = item
      this.$emit('chartSelect', item)
    },
    handleTablePageChange(current, pageSize) {
      this.$emit('table-page-change', current, pageSize)
    },
    handleTableCommand(command) {
      this.$emit('handle-table-command', command)
    },
    handleDrillItemClick(data) {
      this.$emit('drill-item-click', data)
    },
    updateSingleChart() {
      this.$refs[`middle_${this.cur._id}`]?.[0]?.updateSingleChart()
    }
  },
}
</script>

<style scoped lang="less">
.bi-layout-drag-handle {
  z-index: 9;
  height: 12px;
  cursor: grab;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgba(0, 0, 0, .45);
  background: #fff;
  border: 1px solid rgba(0, 0, 0, .12);
  border-radius: 8px;
  align-items: center;
  justify-items: center;
  width: 28px;
  display: grid;
  box-shadow: 0 4px 24px rgba(0, 0, 0, .1);
  top: 0;
  display: none;

  >div {
    height: 5px;
    text-align: center;
    .el-icon-more{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
    }
  }
}

.vue-grid-item:hover {
  .bi-layout-drag-handle {
    display: block;
  }
}

.root-container {
  height: 100%;
  width: 100%;
  position: relative;
  overflow-y: auto;
  scrollbar-gutter: stable;
  user-select: none;
  margin: auto;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 30%);
  grid-auto-rows: minmax(25px, 25px) !important;
  .gap {
    height: 300px;
  }
  .grid-warp {
    border: 1px solid transparent;
    padding: 8px;

    &:hover {
      box-shadow: 0 6px 10px 0 #d8d7dc;
    }
  }

  .gridlayout {
    height: 100% !important;
  }
}
</style>
